import { ApplicationDataRequirementsService } from '@/modules/global-settings/onboarder/services/application-data-requirements.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';

// Create a new instance of the ApplicationDataRequirementsService class
const appDataReq = new ApplicationDataRequirementsService();
// Define the state of the ApplicationDataRequirements module
export const state = {
  applicationDataRequirements: []
};
// Define the mutations of the ApplicationDataRequirements module
export const mutations = {
  ...make.mutations(state)
};
// Define the actions of the ApplicationDataRequirements module
export const actions = {
  /**
   * Create application data requirements
   * @param {Object} object - Vuex context
   * @returns {Array} Array of application data requirements
   * @private This will set the values in state after creating
   */
  createApplicationRequirements: async ({ commit }) => {
    try {
      const { data } = await appDataReq.createApplicationRequirements();
      commit('SET_APPLICATION_DATA_REQUIREMENTS', data);
      return data;
    } catch (error) {
      Logger.error('creating application data requirements');
      throw error;
    }
  },

  /**
   * Get application data requirements
   * @param {Object} object - Vuex context
   * @returns {Array} Array of application data requirements
   * @private This will set the values in state after fetching
   */
  getApplicationRequirements: async ({ commit }) => {
    try {
      const { data } = await appDataReq.getApplicationRequirements();
      //Check if data is empty
      if (data && data.length === 0) {
        await appDataReq.createApplicationRequirements();
        const { data: newData } = await appDataReq.getApplicationRequirements();
        commit('SET_APPLICATION_DATA_REQUIREMENTS', newData);
        return newData;
      }
      commit('SET_APPLICATION_DATA_REQUIREMENTS', data);
      return data;
    } catch (error) {
      Logger.error('getting application data requirements');
      throw error;
    }
  },

  /**
   * Update application data requirements
   * @param {Object} object - Vuex context
   * @param {Object} payload - Payload to be updated
   * @returns {void}
   * @private This will re-fetch the application data requirements after updating
   */
  updateApplicationRequirements: async ({ dispatch }, payload) => {
    try {
      await appDataReq.updateApplicationRequirements(payload);
      dispatch('getApplicationRequirements');
    } catch (error) {
      Logger.error('updating application data requirements');
      throw error;
    }
  }
};
// Define the getters of the ApplicationDataRequirements module
export const getters = {
  ...make.getters(state),
  requiredApplicationDataRequirements(state) {
    return state.applicationDataRequirements.filter((i) => i.required == true);
  }
};
